import { render, staticRenderFns } from "./index.vue?vue&type=template&id=22baaf81"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22baaf81')) {
      api.createRecord('22baaf81', component.options)
    } else {
      api.reload('22baaf81', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=22baaf81", function () {
      api.rerender('22baaf81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/indexes/components/BjCodeSelect/index.vue"
export default component.exports